// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"383":"question","388":"result","962":"home","996":"chunk-common"}[chunkId] || chunkId) + "." + {"383":"789cb0e2","388":"d93c5e3e","570":"81c3361c","962":"9dbe9aa4","996":"6751284f"}[chunkId] + ".js";
};